/* Marcus' Main Squeeze — Theme JS v2 */
(function () {
  'use strict';

  /* Mobile nav */
  var burger = document.getElementById('header-burger');
  var mobileNav = document.getElementById('mobile-nav');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(open));
      mobileNav.setAttribute('aria-hidden', String(!open));
    });
  }

  /* Qty +/- on product page */
  var minus = document.getElementById('qty-minus');
  var plus  = document.getElementById('qty-plus');
  var inp   = document.getElementById('qty-input');
  if (minus && plus && inp) {
    minus.addEventListener('click', function () {
      var v = parseInt(inp.value, 10) || 1;
      if (v > 1) inp.value = v - 1;
    });
    plus.addEventListener('click', function () {
      inp.value = (parseInt(inp.value, 10) || 1) + 1;
    });
  }

  /* Variant pills */
  document.querySelectorAll('.variant-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      var pos = this.dataset.optionPos;
      document.querySelectorAll('.variant-pill[data-option-pos="' + pos + '"]')
        .forEach(function (p) { p.classList.remove('is-active'); });
      this.classList.add('is-active');
    });
  });
  var firstPills = {};
  document.querySelectorAll('.variant-pill').forEach(function (p) {
    var pos = p.dataset.optionPos;
    if (!firstPills[pos]) { p.classList.add('is-active'); firstPills[pos] = true; }
  });

  /* AJAX add-to-cart — product page */
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = productForm.querySelector('#add-to-cart-btn');
      var orig = btn ? btn.textContent : '';
      if (btn) btn.textContent = 'Adding...';
      var id  = (productForm.querySelector('#variant-id') || {}).value;
      var qty = parseInt((productForm.querySelector('#qty-input') || {}).value, 10) || 1;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id, 10), quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function () { refreshCount(); if (btn) { btn.textContent = 'Added!'; setTimeout(function () { btn.textContent = orig; }, 1800); } })
        .catch(function () { if (btn) btn.textContent = orig; });
    });
  }

  /* AJAX add-to-cart — product cards */
  document.querySelectorAll('.product-card-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.btn-gold');
      var orig = btn ? btn.textContent : '';
      if (btn) btn.textContent = 'Adding...';
      var id = (form.querySelector('input[name="id"]') || {}).value;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () { refreshCount(); if (btn) { btn.textContent = 'Added!'; setTimeout(function () { btn.textContent = orig; }, 1800); } })
        .catch(function () { if (btn) btn.textContent = orig; });
    });
  });

  /* Refresh cart count badge */
  function refreshCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.getElementById('cart-count');
        if (!el) return;
        if (cart.item_count > 0) {
          el.textContent = cart.item_count;
          el.classList.remove('cart-count--hidden');
        } else {
          el.classList.add('cart-count--hidden');
        }
      });
  }

})();
